<template>
  <NuxtLink
    :to="props.block.url"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center gap-x-4 rounded-[20px] border border-black/20 bg-white p-5 text-black no-underline transition-colors hover:bg-black/[0.03]"
    :class="isLarge ? 'md:h-40 md:gap-x-8' : 'md:h-20 md:gap-x-5 md:p-4'"
  >
    <span
      class="bg-mint text-blue-dark flex flex-none items-center justify-center rounded-[10px]"
      :class="isLarge ? 'size-12 md:size-30' : 'size-12'"
    >
      <SvgIconBook v-if="isLarge" class="h-auto w-[58%]" />
      <SvgIconDocument v-else class="h-[64%] w-auto" />
    </span>
    <span
      class="min-w-0 flex-1 text-[16px]/[1.2em] font-medium tracking-[0.01em] text-black"
      :class="isLarge ? 'md:text-[22px]/[1.2em]' : ''"
      v-text="props.block.description"
    />
    <SvgGlyphDownload
      class="size-6 flex-none text-black"
      :class="isLarge ? 'md:mr-5 md:size-10' : 'md:mr-3'"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import type { DownloadWidgetBlock } from '#payload-types'

interface RichTextDownloadWidgetProps {
  block: DownloadWidgetBlock
}

const props = defineProps<RichTextDownloadWidgetProps>()

const isLarge = computed(() => props.block.type === 'large')
</script>
